<template>
  <span :class="`icon icon--${icon}`">
    <svg>
      <title v-if="title">{{ title }}</title>
      <use :xlink:href="`#icon--${icon}`"></use>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    icon: {
      required: true,
      type: String
    },
    title: {
      required: false,
      default: null
    }
  }
}
</script>
